// Single source of truth for upload size limits across the app. Server enforces
// the same number via multer (server/src/routes/riskAssessment.ts and
// assetInventory.ts) and surfaces a 413 with code='LIMIT_FILE_SIZE' if a
// client bypasses this client-side validation.
export const MAX_UPLOAD_BYTES = 99 * 1024 * 1024
export const MAX_UPLOAD_LABEL = '99MB'

// Returns null if the file is within the limit, otherwise a user-facing
// rejection message. Caller is expected to show the message via toast and
// skip the upload for this file.
export function validateUploadSize(file: File | { name: string; size: number }): string | null {
  if (file.size > MAX_UPLOAD_BYTES) {
    return `File "${file.name}" is ${(file.size / 1024 / 1024).toFixed(1)}MB, exceeds ${MAX_UPLOAD_LABEL} limit.`
  }
  return null
}
